/**
 * Company-name randomizer for the registration/reset company-setup step
 * (src/ui/components/CompanySetupFields.js). Template-based (prefix + noun +
 * suffix) rather than a flat name list like shipNames.js — a small amount of
 * data gives a lot of variety, and there's no "already used" recycling
 * concern the way ship names have (multiple players can share a company
 * name; it's cosmetic display text, not a unique identifier).
 *
 * Deliberately uses plain Math.random(), not the seeded src/utils/random.js
 * — this is picked once at account-setup time (pre-game, no WS connection
 * yet for a fresh registration), and has no gameplay-reproducibility
 * requirement, same reasoning as the company-colour default hash in
 * server/game/bootstrap.js.
 */
const PREFIXES = [
  'Blue', 'Golden', 'Northern', 'Pacific', 'Atlantic', 'Silver', 'Crimson',
  'Iron', 'Azure', 'Emerald', 'Coral', 'Amber', 'Ivory', 'Scarlet', 'Cobalt',
  'Sterling', 'Royal', 'Southern', 'Eastern', 'Western', 'Midnight', 'Rising'
];

const NOUNS = [
  'Horizon', 'Star', 'Wave', 'Tide', 'Compass', 'Anchor', 'Voyager',
  'Mariner', 'Current', 'Harbor', 'Odyssey', 'Passage', 'Meridian', 'Beacon',
  'Cascade', 'Summit', 'Frontier', 'Expedition', 'Trident', 'Nautilus'
];

const SUFFIXES = [
  ' Shipping', ' Trading Co.', ' Maritime', ' Lines', ' Freight',
  ' Logistics', ' Navigation', ' Cargo Co.', ''
];

function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

/** Generate a random company name, e.g. "Golden Compass Trading Co." */
export function pickCompanyName() {
  return `${pick(PREFIXES)} ${pick(NOUNS)}${pick(SUFFIXES)}`;
}
